import { useEffect, useState } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';

import { useAppDispatch } from '../../store/hooks';
import ButtonLoader from '../../pages/ButtonLoader';
import { deleteJob } from '../../store/features/dashboard';
import { getUserProfile } from '../../store/features/auth';
import { getValue, handleSuccess, storeValue, renderErrorToast } from '../../utility/helpers';

const DeleteJob = ({
    showDeleteJob,
    deleteJobId,
    setShowDeleteJob,
    refreshJobsList
}: any) => {
    const dispatch = useAppDispatch();
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        if (!showDeleteJob) {
            setDeleting(false);
        }
    }, [showDeleteJob]);

    const updateUserDetail = async () => {
        try {
            const companyId = getValue('companyId');
            const payload = {
                companyId,
                loader: false
            };
            const res = await dispatch(getUserProfile(payload)).unwrap();
            storeValue('canCreateJob', res.data.job_left);
        } catch (error) {
            console.info('Error during fetching user details:', error);
        }
    };

    const handleDeleteJob = () => {
        // Additional safeguard: Check tier data before allowing deletion
        // This prevents race condition where user might bypass UI checks
        let cachedTierData = null;
        try {
            const tierData = getValue('tierData');
            if (tierData) {
                cachedTierData = JSON.parse(tierData);
            }
        } catch (error) {
            console.info('Error parsing cached tier data:', error);
        }
        
        if (cachedTierData?.mask === true) {
            renderErrorToast('Delete is disabled for demo accounts. Please upgrade your plan.');
            setShowDeleteJob(false);
            return;
        }

        setDeleting(true);
        dispatch(deleteJob(deleteJobId))
            .unwrap()
            .then((res: any) => {
                handleSuccess(res?.detail || 'Job deleted successfully.');
                refreshJobsList();
                updateUserDetail();
                setShowDeleteJob(false);
            })
            .catch((error: any) => {
                console.info('Error deleting job:', error);
            })
            .finally(() => {
                setDeleting(false);
            });
    };
    return (
        <>
            < Modal show={showDeleteJob}
                    dialogClassName="modal-signout top-right-modal modal-dialog-centered "
                    className="confirmation-modal sign-up-modal delete-job-modal"
            >
                <Modal.Body>
                    <h4 className="modal-head modal-head-medium">Delete Job Search</h4>
                    <p className='modal-subhead'>Are you sure you want to delete this job search?</p>
                    <div className='form-wrap'>
                        <Form className="full-width-form">
                            <div className="sign-btn-wrapper tier-btn-wrap">

                                <Button
                                    variant="danger"
                                    onClick={handleDeleteJob}
                                    className="submit-btn scale delete-job-modal-confirm-btn"
                                    disabled={deleting}
                                >
                                    {deleting ? <ButtonLoader /> : 'yes, delete'}
                                </Button>
                                <Button
                                    className="delete-job-modal-cancel-btn"
                                    disabled={deleting}
                                    onClick={() => setShowDeleteJob(false)}
                                >
                                    not now
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </ Modal>
        </>
    );
};

export default DeleteJob;
